import { makeStyles } from '@mui/styles';
const indicativeNumberStyles = makeStyles(({ breakpoints }) => ({
    indicativeNumber: {
        fontSize: 10,
        position: 'relative',
        cursor: 'pointer',
        top: ({ topOffset }) => (topOffset ? `-${topOffset}px` : '-5px'),
        [breakpoints.down('md')]: {
            top: ({ topOffset }) => (topOffset ? `-${topOffset - 1}px` : '-5px'),
        },
    },
}), { name: 'Common_IndicativeNumber' });
export default indicativeNumberStyles;
//# sourceMappingURL=indicativeNumber.styles.js.map